(ns ycweb.app.admin.storeplans.summary
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.admin.storeplans.common :as sp.cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc stats < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        store-plan (cmn/curact process-atom [:store-plan])
        plan-stats (:store-plan/stats store-plan)
        days (if (pos? (cmn/curact process-atom :days)) (cmn/curact process-atom :days) 90)
        brands
        (->>
          (:store-plan/brands store-plan)
          (map
            (fn [[_ brand]]
              {:text (:brand/name brand)
               :value (:brand/id brand)}))
          (sort-by :text))

        {:stats/keys [cost-price-sales skus qty es-plan cost-price-value retail-price-value face-needed volume-needed
                      non-shared-plan current-skus current-qty current-cost-price-value current-retail-price-value
                      es-current non-shared-current]} plan-stats

        planned-stock-turn
        (when (and cost-price-sales (pos? cost-price-sales) cost-price-value (pos? cost-price-value))
          (yuc/round (/ (/ (* cost-price-sales 365) days) cost-price-value) 1))

        current-stock-turn
        (when (and cost-price-sales (pos? cost-price-sales) current-cost-price-value (pos? current-cost-price-value))
          (yuc/round (/ (/ (* cost-price-sales 365) days) current-cost-price-value) 1))

        percent-planned-es-skus
        (when
          (and (:skus es-plan) (pos? (:skus es-plan)) skus (pos? skus))
          (yuc/round (/ (* (:skus es-plan) 100) skus)))

        current-planned-es-skus
        (when
          (and (:skus es-plan) (pos? (:skus es-plan)) current-skus (pos? current-skus))
          (yuc/round (/ (* (:skus es-plan) 100) current-skus)))

        planned-es-stock-value
        (when
          (and (:cost-price-value es-plan) (pos? (:cost-price-value es-plan)) cost-price-value (pos? cost-price-value))
          (yuc/round (/ (* (:cost-price-value es-plan) 100) cost-price-value)))

        current-es-stock-value
        (when
          (and (:cost-price-value es-current) (pos? (:cost-price-value es-current))
            current-cost-price-value (pos? current-cost-price-value))
          (yuc/round (/ (* (:cost-price-value es-current) 100) current-cost-price-value)))

        planned-non-shared-brand-skus
        (when
          (and (:skus non-shared-plan) (pos? (:skus non-shared-plan)) skus (pos? skus))
          (yuc/round (/ (* (:skus non-shared-plan) 100) skus)))

        current-non-shared-brand-skus
        (when (and (:skus non-shared-current) (pos? (:skus non-shared-current)) current-skus (pos? current-skus))
          (yuc/round (/ (* (:skus non-shared-current) 100) current-skus)))

        planned-non-shared-brand-value
        (when
          (and (:cost-price-value non-shared-plan) (pos? (:cost-price-value non-shared-plan))
            cost-price-value (pos? cost-price-value))
          (yuc/round (/ (* (:cost-price-value non-shared-plan) 100) cost-price-value)))

        current-non-shared-brand-value
        (when
          (and (:cost-price-value non-shared-current) (pos? (:cost-price-value non-shared-current))
            current-cost-price-value (pos? current-cost-price-value))
          (yuc/round (/ (* (:cost-price-value non-shared-current) 100) current-cost-price-value)))]

    [:div
     {:class (yuc/bem :flex-grid-block [:m-1-3])}
     [:div.flex-grid-content.stats-table-card
      [:table.stats-table
       [:thead
        [:tr.stats-table__row
         [:td.stats-table__th]
         [:td.stats-table__th.u-text-right [:b "Planned Stock"]]
         [:td.stats-table__th.u-text-right [:b "Actual Stock"]]]]
       [:tbody
        [:tr.stats-table__row
         [:th.stats-table__th [:b "SKU's:"]]
         [:td.stats-table__td.u-text-right skus]
         [:td.stats-table__td.u-text-right current-skus]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Qty:"]]
         [:td.stats-table__td.u-text-right qty]
         [:td.stats-table__td.u-text-right current-qty]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Stock Value:"]]
         [:td.stats-table__td.u-text-right "R" (yuc/currency-format (* cost-price-value 100) 0 ",")]
         [:td.stats-table__td.u-text-right "R" (yuc/currency-format (* current-cost-price-value 100) 0 ",")]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Retail Value:"]]
         [:td.stats-table__td.u-text-right "R" (yuc/currency-format (* retail-price-value 100) 0 ",")]
         [:td.stats-table__td.u-text-right "R" (yuc/currency-format (* current-retail-price-value 100) 0 ",")]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Stock Turn"]]
         [:td.stats-table__td.u-text-right planned-stock-turn]
         [:td.stats-table__td.u-text-right current-stock-turn]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "ES SKU's:"]]
         [:td.stats-table__td.u-text-right percent-planned-es-skus "%"]
         [:td.stats-table__td.u-text-right current-planned-es-skus "%"]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "ES Stock Value:"]]
         [:td.stats-table__td.u-text-right planned-es-stock-value "%"]
         [:td.stats-table__td.u-text-right current-es-stock-value "%"]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Non-Shared Brand SKU's:"]]
         [:td.stats-table__td.u-text-right planned-non-shared-brand-skus "%"]
         [:td.stats-table__td.u-text-right current-non-shared-brand-skus "%"]]
        [:tr.stats-table__row
         [:th.stats-table__th [:b "Non-Shared Brand Value:"]]
         [:td.stats-table__td.u-text-right planned-non-shared-brand-value "%"]
         [:td.stats-table__td.u-text-right current-non-shared-brand-value "%"]]]]

      [:div.input-combo
       (forms/select "Brand:"
         (rum/cursor-in process-atom [:store-plan/selected-brand])
         (concat
           [{:text "- Select a Brand -" :value nil}]
           brands))
       (buttons/button-web "Go"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :store-plan/reset-rows
             {:filter-type :brands})
          :style :primary
          :size :medium
          :full false
          :persistent true
          :flat-style :flat})]]]))

(rum/defcs suggested-filters < rum/reactive (rum/local {} ::state) [s app-atom]
  (let [local-atom (::state s)
        selected-atom (rum/cursor local-atom :selected-item)
        process-atom (cmn/process-cursor app-atom)
        days (if (pos? (cmn/curact process-atom :days)) (cmn/curact process-atom :days) 90)]
    [:div
     {:class (yuc/bem :flex-grid-block [:m-1-3])}
     [:div.flex-grid-content.stats-table-card
      [:div
       {:class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid :grow-yes])}
        [:div.flex-grid-content
         (headings/heading "Suggested Filters"
           {:type :h3
            :size :small})]]
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (buttons/button-web "Reset"
           (merge
             (urlstate/href-on-click
               #(do
                  (reset! selected-atom nil)
                  (grid/dispatch-action app-atom :store-plan/apply-filter
                    {:datatable-key :admin.store-plans/summary.datatable
                     :sort-on
                     {:column-title "Product" :order :asc}
                     :filter-on {}})))
             {:small true
              :style :secondary
              :size :default}))]]]

      [:b "Weekly"]
      [:ul
       {:class (yuc/bem :yc-list [:small])}
       (sp.cmn/suggested-filter-item app-atom selected-atom "Slow Stock Turn" "(Reduce Plan Qty)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Min Qty for Display" :order :asc}
          :filter-on
          {"Min Qty for Display" ">0"
           "Store Plan Qty" ">0"
           "Plan Qty - Display" ">0"
           (str "Store Avg SOH (" days " Days)") ">1.9"
           (str "Store Sales (" days " Days)") ">=0"
           "Annual Turn (From Plan)" "<6.1"
           "Annual Turn (From Avg On Hand)" "<6.1"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Fast Movers" "(Increase Plan Qty)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title  (str "Store Sales (" days " Days)") :order :asc}
          :filter-on
          {"Min Qty for Display" ">0"
           "Store Plan Qty" ">0"
           "Annual Turn (From Plan)" ">8"
           "Annual Turn (From Avg On Hand)" ">8"}})]

      [:ul
       {:class (yuc/bem :yc-list [:small])}
       (sp.cmn/suggested-filter-item app-atom selected-atom "Has Sold in Store, Not in Plan" "(Add to Plan?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Supplier SOH" :order :asc}
          :filter-on
          {"Product Live" "Live"
           "Store Plan Qty" "<=0"
           "Non Picking Stock" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Have SOH, Not in Plan" "(Add to Plan?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Plan Value" :order :asc}
          :filter-on
          {"Product Live" "Live"
           "Store Plan Qty" "<=0"
           "Store SOH" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "No AVG SOH, In Plan" "(Remove from Plan/Alert Store?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Min Qty for Display" :order :asc}
          :filter-on
          {"Store Plan Qty" ">0"
           (str "Store Avg SOH (" days " Days)") "<=0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Need more in Store, Supplier Out" "(Remove from Plan/Alert Store?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Non Picking Stock" :order :asc}
          :filter-on
          {"Supplier Available" "!Yes"
           "Store Plan Qty" ">0"
           "HQ Free Stock" "<=0"
           "HQ Stock On Future Order" "<=0"
           (str "Store Sales (" days " Days)") ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "More SOH than in Plan" "(Reverse IBT?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Non Picking Stock" :order :desc}
          :filter-on
          {(str "Store Sales (" days " Days)") "<0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Not Live on Site, in Plan" "(Remove/Reduce from Plan?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title "Min Qty for Display" :order :asc}
          :filter-on
          {"Product Live" "!Live"
           "Store Plan Qty" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Needed at HQ - Paid Orders" " (Reduce Plan and Reverse IBT?)"
         {:datatable-key :admin.store-plans/summary.datatable
          :sort-on
          {:column-title (str "Store Sales (" days " Days)") :order :desc}
          :filter-on
          {"Supplier Available" "!Yes"
           "Store SOH" ">0"
           "HQ Stock On Future Order" "<=0"
           "Supplier SOH" "<500"
           "Annual Turn (From Avg On Hand)" ">0"}})]

      [:div.input-combo
       (forms/input "Days:" ""
         (rum/cursor process-atom :days)
         {:type :number})
       (buttons/button-web "Go"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :store-plan/reset-rows
             {:filter-type :days})
          :style :primary
          :size :medium
          :full false
          :persistent true
          :flat-style :flat})]]]))

(rum/defc master-links < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:store-plan/keys [id]} (cmn/curact process-atom [:store-plan])]
    [:div
     {:class (yuc/bem :flex-grid-block [:m-1-3])}
     [:div.flex-grid-content.stats-table-card
      (headings/heading "Suggested Master Reports"
        {:type :h3
         :size :small})
      [:ul
       {:class (yuc/bem :yc-list [:small])}

       [:li
        [:a.text-link
         (merge
           {:target "_blank"}
           (urlstate/href-props app-atom "master" ""
             {:datefrom_days 90
              :grouping "list"
              :levels "1"
              "catid[0]" 157
              :manufacturing "no"
              :supplier "647"
              "show[brand]" "1"
              "show[storeplan_qty]" "1"
              "show[edit]" "1"
              "show[income]" "1"
              "show[units]" "1"
              "show[valueonhand]" "1"
              "show[qtyonhand]" "1"
              "show[qtysupplieronhand]" "1"
              "show[registries_listings]" ""
              "show[registries_sales]" ""
              :storeplan_id id
              :datecolumn "dateplaced"
              :colorder [5 1]
              :colfilters ["" "" "Y" "" "" "" ">2" "" "" "" "<=0"]}))
         "Not Allocated - Edison Stone"]]

       [:li
        [:a.text-link
         (merge
           {:target "_blank"}
           (urlstate/href-props app-atom "master" ""
             {:datefrom_days 7
              :grouping "list"
              :levels "1"
              "catid[0]" 156
              :manufacturing "no"
              "show[brand]" "1"
              "show[storeplan]" id
              "show[storeplan_qty]" "1"
              "show[edit]" "1"
              "show[qtyonhand]" "1"
              "show[qtysupplieronhand]" "1"
              "show[registries_listings]" ""
              "show[registries_sales]" ""
              :storeplan_id id
              :datecolumn "dateplaced"
              :colorder [4 1]
              :colfilters ["" "" "" "" "" "" "" "" "<=0" "" "" ""]}))
         "Lots of stock on hand, but not in plan"]]

       [:li
        [:a.text-link
         (merge
           {:target "_blank"}
           (urlstate/href-props app-atom "master" ""
             {:datefrom_days 30
              :grouping "9:70:157:"
              :levels "1"
              "catid[0]" 156
              :manufacturing "no"
              :storeplan_id id
              "show[income]" "1"
              "show[costofstock]" "1"
              "show[gp]" "1"
              "show[gpperc]" "1"
              "show[valueonhandavg]" "1"
              "show[stockturn]" "1"
              "show[registries_listings]" ""
              "show[registries_sales]" ""
              (str "store[" id "]") "1"
              :datecolumn "dateplaced"
              :colorder [1 1]}))
         "Top Brands Sold in Store (30 days)"]]

       [:li
        [:a.text-link
         (merge
           {:target "_blank"}
           (urlstate/href-props app-atom "master" ""
             {:datefrom_days 30
              :grouping "list"
              :levels "1"
              "catid[0]" 156
              :manufacturing "no"
              :addedfrom_days 30
              "show[storeplan_qty]" "1"
              "show[income]" "1"
              "show[units]" "1"
              "show[registries_listings]" ""
              "show[registries_sales]" ""
              :storeplan_id id
              :datecolumn "dateplaced"
              :colorder [2 1]
              :colfilters ["" "" "" "" "<=0"]}))
         "New Products (30 days)"]]

       [:li
        [:a.text-link
         (merge
           {:target "_blank"}
           (urlstate/href-props app-atom "master" ""
             {:datefrom_days 365
              :grouping "list"
              :levels "1"
              "catid[0]" 156
              :manufacturing "no"
              :isgift "yes"
              "show[storeplan_qty]" "1"
              "show[income]" "1"
              "show[units]" "1"
              "show[registries_listings]" ""
              "show[registries_sales]" ""
              :storeplan_id id
              :datecolumn "dateplaced"
              :colorder [2 1]
              :colfilters ["" "Y" "" "" "<=0"]}))
         "Top Gifting Products (365 days)"]]]]]))

(def summary-table-fns
  {:column-fns
   {:qty-edit-fn
    (editor/edit-field :admin.store-plans/summary.editor :inline
      {:onblur-fn :submit
       :on-open :clear
       :classes "text-input--small"
       :style {:width "80px"}})
    :product-link-fn
    (fn [app-atom row col cell-val]
      [:a
       {:href
        (str "/admin/pages_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]=" (:product/id row))
        :target "_blank"}
       cell-val])
    :freestock-link-fn
    (fn [app-atom row col cell-val]
      [:a
       {:href
        (str "/admin/freestock.htm?overrideincludes=popup&variationid=" (:variation/id row))
        :target "_blank"}
       cell-val])
    :log-link-fn
    (fn [app-atom row col cell-val]
      [:a
       {:href
        (str "storeplans.htm?action=changelog&overrideincludes=popup&variation_id=" (:variation/id row) "&plan_id=" (:store-plan/id row))
        :target "_blank"}
       "Log"])}})

(def summary-editor-config
  {:editor-name :admin.store-plans/summary.editor
   :datatable :admin.store-plans/summary.datatable
   :mode :read
   :end-points
   {:edit :admin.store-plans/update}
   :fields
   [{:name :store-plan/total-qty
     :label "Quantity:"
     :type :text
     :attr {:type :number}}
    {:name :store-plan/in-store-stock-qty
     :label "Quantity:"
     :type :text
     :attr {:type :number}}
    {:name :store-plan/mdq
     :label "Quantity:"
     :type :text
     :attr {:type :number}}
    {:name :variation/id
     :type :hidden}
    {:name :store-plan/id
     :type :hidden}]})

(defn summary-column-defs [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        days (if (pos? (cmn/curact process-atom :days)) (cmn/curact process-atom :days) 90)]
    [{:key :variation/id
      :title "Variation ID"
      :align-class :u-text-center}
     {:key :store-plan/id
      :title "Store Plan ID"
      :align-class :u-text-center}
     {:key :company/name
      :title "Supplier"}
     {:key :brand/root-name
      :title "Brand"}
     {:key :product/id
      :title "Product ID"}
     {:key :product/name
      :title "Product"
      :align-class :u-text-left
      :render {:render-k :product-link-fn}}
     {:key :variation/code
      :title "Code"}
     {:key :variation/features
      :title "Features"}
     {:key :variation/end-use
      :title "End Use"}
     {:key :category/full-name
      :title "Category"}
     {:key :product/status
      :title "Product Live"
      :align-class :u-text-center}
     {:key :supplier/availability
      :title "Supplier Available"
      :align-class :u-text-center}
     {:key :supplier/estimated-arrival-time
      :title "Supplier ETA"
      :align-class :u-text-center
      :type :date
      :dateformat "Y-MM-dd"
      :default nil}
     {:key :store-plan/mdq
      :title "Min Qty for Display"
      :type :number
      :col-classes
      (concat
        [:cell-group-colour]
        (yuc/bem :cell-status [:is-editable]))
      :cell-edit :qty-edit-fn}
     {:key :store-plan/in-store-stock-qty
      :title "Store In Stock Qty"
      :type :number
      :col-classes
      (concat
        [:cell-group-colour]
        (yuc/bem :cell-status [:is-editable]))
      :cell-edit :qty-edit-fn}
     {:key :store-plan/total-qty
      :title "Store Plan Qty"
      :type :number
      :col-classes
      (concat
        [:cell-group-colour]
        (yuc/bem :cell-status [:is-editable]))
      :cell-edit :qty-edit-fn}
     {:key :store-plan/display-qty
      :title "Plan Qty - Display"
      :type :number
      :align-class :u-text-right}
     {:key :variation/cost-price
      :title "Cost Price"
      :type :currency
      :align-class :u-text-right}
     {:key :store-plan-variation/sub-total
      :title "Plan Value"
      :type :currency
      :align-class :u-text-right}
     {:key :stock/on-hand
      :title "Store SOH"
      :type :number}
     {:key :stock/transit-ibt
      :title "Transit IBTs"
      :type :number}
     {:key :stock/store-ibt
      :title "Pending IBTs"
      :type :number}
     {:key :store/on-hand-history-avg
      :title (str "Store Avg SOH (" days " Days)")
      :type :number
      :decimals 1}
     {:key :variation/free-stock
      :title "HQ Free Stock"
      :align-class :u-text-right
      :render {:render-k :freestock-link-fn}}
     {:key :variation/ringfenced-qty
      :title "HQ Ringfenced Qty"
      :align-class :u-text-right}
     {:key :variation/on-order
      :title "HQ Stock On Order"
      :type :number}
     {:key :variation/future-order
      :title "HQ Stock On Future Order"
      :type :number}
     {:key :variation/supplier-on-hand
      :title "Supplier SOH"
      :type :number}
     {:key :variation/non-picking-stock
      :title "Non Picking Stock"
      :type :number}
     {:key :store/sales
      :title (str "Store Sales (" days " Days)")
      :type :number}
     {:key :stock/qty-on-hand
      :title "Plan - (SOH + IBT)"
      :type :number}
     {:key :store/stock-turn
      :title "Annual Turn (From Plan)"
      :type :number
      :decimals 1}
     {:key :store/stock-turn-avg
      :title "Annual Turn (From Avg On Hand)"
      :type :number
      :decimals 1}
     {:key :stock/needed-at-hq
      :title "Needed at HQ"
      :type :number}
     {:key :variation/id
      :title "Log"
      :render {:render-k :log-link-fn}}]))

(rum/defc header-link-row < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:store-plan/keys [id]} (cmn/curact process-atom [:store-plan])]
    [:p
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "allocate"
          {:planid id
           :overrideincludes "popup"}))
      "Allocate to Shelves"]
     [:span.u-pipe " | "]
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "printwithstock"
          {:planid id
           :overrideincludes "popup"}))
      "Print By Bay With Stock"]
     [:span.u-pipe " | "]
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "printbybarcode"
          {:planid id
           :overrideincludes "popup"}))
      "Print By Barcode"]
     [:span.u-pipe " | "]
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "printwithoutstock"
          {:planid id
           :overrideincludes "popup"}))
      "Print Plan (without stock)"]
     [:span.u-pipe " | "]
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "orderfromsuppliers"
          {:planid id
           :overrideincludes "popup"}))
      "Order from Suppliers"]
     [:span.u-pipe " | "]
     [:a
      (merge
        {:class (yuc/bem :text-link [:muted])}
        (urlstate/href-props app-atom "storeplans" "shelfsummary"
          {:id id}))
      "Shelf Face & Volume Summary"]]))

(defn summary-grid-columns [app-atom]
  (let [process-name (cmn/process-name app-atom)]
    {:table-name :admin.store-plans/summary.datatable
     :row-id :variation/id
     :data-source
     {:cursor [process-name :store-plan :store-plan/items]}
     :options
     {:order :asc
      :sort-title "Product"
      :paging? true
      :pagination {:page 0 :page-size 20}}
     :column-defs (summary-column-defs app-atom)}))

(rum/defc store-plan-page < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        store-plan-data (cmn/curact process-atom [:store-plan])]
    [:div
     [:div
      {:class (yuc/bem :flex-grid-group [:flush :align-left])}
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid :flush :grow-yes])}
       [:div.flex-grid-content
        (headings/heading (str "Store Plan - " (:store-plan/name store-plan-data)) {:type :h1 :size :large})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid :flush])}
       [:div.flex-grid-content
        (buttons/button-web "Back to Store Plans"
          (merge
            (urlstate/href-props app-atom "storeplans")
            {:style :secondary
             :size :default}))]]]

     (header-link-row app-atom)

     [:div
      {:class (yuc/bem :flex-grid-group [:flush])}
      (stats app-atom)
      (suggested-filters app-atom)
      (master-links app-atom)]

     (datatables/table app-atom
       :admin.store-plans/summary.datatable
       summary-table-fns)
     (toaster/loading-overlay app-atom :admin.store-plans/summary-loading-overlay)]))

(defmethod flow/render-screen :admin.storeplans/new-summary [app-atom _]
  (store-plan-page app-atom))

(defmethod t/transition-open :admin.storeplans/new-summary [app-atom _ {:keys [id days brandid]}]
  (toaster/open-overlay app-atom :admin.store-plans/summary-loading-overlay {:text "Store Plan: Loading Data"})
  (comms/send :admin.store-plans/summary
    (yuc/maybe assoc {:store-plan/id id}
      :days days
      :brand/id (yuc/presence brandid))))

(defmethod t/transition-after-open :admin.storeplans/new-summary [app-atom _ _]
  (datatables/initiate app-atom (summary-grid-columns app-atom) summary-table-fns)
  (editor/initiate app-atom summary-editor-config))

(defmethod comms/receive :admin.store-plans/update
  [app-atom submission-response]
  (let [status (editor/post-submit app-atom :admin.store-plans/summary.editor submission-response)
        {:keys [row-id table-name]} (summary-grid-columns app-atom)

        table-atom (datatables/table-cursor app-atom table-name)
        table-cfg (:config @table-atom)
        data-src (:data-source table-cfg)]

    (when (:success status)
      (swap! app-atom update-in (:cursor data-src)
        (fn [items]
          (reduce
            (fn [acc row]
              (let [current-id (get row row-id)
                    current-row (get acc current-id)]
                (assoc acc
                  current-id
                  (yuc/maybe assoc current-row
                    :editing? false
                    :store-plan/mdq (:store-plan/mdq row)
                    :store-plan/in-store-stock-qty (:store-plan/in-store-stock-qty row)
                    :store-plan/total-qty (:store-plan/total-qty row)))))
            items
            (:rows submission-response)))))))

(defmethod grid/action :store-plan/reset-rows [app-atom {:keys [filter-type]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        store-plan (cmn/curact process-atom :store-plan)
        days (cmn/curact process-atom :days)
        brand-id (cmn/curact process-atom :store-plan/selected-brand)

        config
        (yuc/maybe assoc {:id (:store-plan/id store-plan)}
          :brandid (when (and (> (trf/tonumber brand-id) 0) (= filter-type :brands)) brand-id)
          :days (when (and days (= filter-type :days)) days))]

    (urlstate/redirect app-atom "storeplans" "new-summary" config)))

(defmethod comms/receive :admin.store-plans/summary
  [app-atom {:keys [store-plan days brand-id store-plan-items avg-on-hand sales on-hand brands-idx]}]
  (toaster/update-overlay-message app-atom :admin.store-plans/summary-loading-overlay {:text "Store Plan: Processing Data"})
  (let [now (dt/now)
        process-atom (cmn/process-cursor app-atom)
        idx-avg-on-hand (yuc/index-by :vid avg-on-hand)
        idx-sales (yuc/index-by :vid sales)
        {:keys [ibt-in-transit ibt-pending stores]} on-hand
        idx-ibt-in-transit (yuc/index-by :vid ibt-in-transit)
        idx-ibt-pending (yuc/index-by :vid ibt-pending)
        idx-stores (yuc/index-by :vid stores)

        rows
        (map
          (fn [row]
            (let [vid (:vid row)]
              (sp.cmn/transform-store-plan-item row now days
                (get idx-avg-on-hand vid)
                (get idx-sales vid)
                (get idx-ibt-in-transit vid)
                (get idx-ibt-pending vid)
                (get idx-stores vid))))
          store-plan-items)

        plan-stats (sp.cmn/build-variation-stats rows)]

    (swap! process-atom assoc
      :days days
      :store-plan/selected-brand brand-id
      :store-plan
      (assoc store-plan
        :store-plan/brands brands-idx
        :store-plan/items (yuc/index-by :variation/id rows)
        :store-plan/stats plan-stats))

    (toaster/close-overlay app-atom :admin.store-plans/summary-loading-overlay)))